import React, { useState, useContext, useEffect } from "react";
import { EWContext } from "../../../context/EWContext";
import AddMoreFieldsButton from "./AddMoreFieldsButton/AddMoreFieldsButton";
import EligibilityInput from "./EligibilityInput/EligibilityInput";
import EligibilityInputArea from "./EligibilityInputArea/EligibilityInputArea";
import EligibilitySelect from "./EligibilitySelect/EligibilitySelect";
import EligibilityCheckbox from "./EligibilityCheckbox/EligibilityCheckbox";
import AddressAutocomplete from "./AddressAutocomplete/AddressAutocomplete";
import EligibilityAccordion from "./EligibilityCheckbox/EligibilityAccordion";
import EligibilityDate from "./EligibilityDate/EligibilityDate";
import EligibilityStaticDate from "./EligibilityStaticDate/EligibilityStaticDate";
import EligibilityAutocomplete from "./EligibilityAutocomplete/EligibilityAutocomplete";
import TermsAndConditions from "./TermsAndConditions/TermsAndConditions";
import UploadFiles from "./UploadFiles/UploadFiles";
import Grid from "@material-ui/core/Grid";
import gridStyles from "../../../theme/gridStyles";
import { arrayFieldsToObject, findElementIntoArray, calculateDate, truncateString } from "../../../utils/utils";
import { getReferencedFields, searchApplyInteractions } from "../../../utils/interactions";
import { cleanMasks } from "../../../utils/textMasks";
import { isEmpty } from 'lodash';
import { tandcQuestions } from "./TermsAndConditions/tandcHelper";

export default function EligibilityQuestions(props) {
  const {
    questions,
    answers,
    onFormAnswered,
    customConfig,
    resetValues,
    defaultGridStyles,
    idSection
  } = props;

  const [accountState, setAccountState] = useContext(EWContext);
  const {
    baseUrl,
    answers: answersObj,
    version,
    skeduloJobData,
    productInfo,
    openTermsAndConditions,
    truncate_zip_code
  } = accountState;

  const [stateForm, setStateForm] = useState(() => {
    return arrayFieldsToObject(questions, "id", answers, version);
  });

  const [tandcReaded, setTandcReaded] = useState(false);
  const tandcQuestion = useState(tandcQuestions(questions))[0];

  useEffect(() => {
    setStateForm(arrayFieldsToObject(questions, "id", answers, version));
  }, [questions, answers, version]);

  const productType = productInfo?.appointmentJobType;
  const zipCode = answersObj.validate?.filter(item => item.id === "zip")[0]?.value;

  const getDate = (limit, question) => {
    let date = undefined;
    let field = undefined;
    let message = undefined;
    const rangeDates = question.field.rangeDates;
    const formatDate = question.field.format;

    switch (limit) {
      case "min":
        const minFieldReference = rangeDates?.minDate?.fieldReference;

        if (minFieldReference && answersObj[minFieldReference?.group]) {
          field = findElementIntoArray(answersObj[minFieldReference?.group], "id", minFieldReference?.id);
          date = field?.value;
          message = field?.label ? `${question.label} must be after the ${field.label}` : undefined;
        } else if (rangeDates?.minDate?.date) {
          date = calculateDate(rangeDates.minDate.date, formatDate);
          message = rangeDates?.minDate?.message;
        }
        break;
      case "max":
        const maxFieldReference = rangeDates?.maxDate?.fieldReference;

        if (maxFieldReference && answersObj[maxFieldReference?.group]) {
          field = findElementIntoArray(answersObj[maxFieldReference?.group], "id", maxFieldReference.id);
          date = field?.value;
          message = field?.label ? `${question.label} must be before the  ${field.label}` : undefined;
        } else if (rangeDates?.maxDate?.date) {
          date = calculateDate(rangeDates.maxDate.date, formatDate);
          message = rangeDates?.maxDate?.message;
        }
        break;
      default:
        break;
    }
    return { date, message };
  };

  const unifiedCallback = (response, lastFieldModified) => {
    const referencedFields = getReferencedFields(questions);

    if(referencedFields.length > 0 && referencedFields.includes(lastFieldModified.id)) {
      searchApplyInteractions(lastFieldModified, questions, answers);
    }

    onFormAnswered(
      {
        ...stateForm,
        ...response
      },
      lastFieldModified,
      idSection
    );
  }


  const handlerAddMoreClick = () => {
    return;
  }

  const handleSelectChange = ({ value, textValue }, id) => {
    const lastFieldModified = {
      id,
      value,
      textValue
    }
    setStateForm((prevStateForm) => ({
      ...prevStateForm,
      [id]: { value, textValue },
    }));
    unifiedCallback({ [id]: { value, textValue } }, lastFieldModified);
  };

  const handlerInputChange = (value, question, extraValues) => {
    let textValue = value;
    let maskType = question.field.maskType;
    if (question.id === "phoneNumber") {
      // Remove validation after maskType setting is added in JSON
      maskType = "phone";
    }
    value = maskType ? cleanMasks(maskType, value) : value;
    const lastFieldModified = {
      id: question.id,
      value,
      textValue,
      extraValues
    }
    setStateForm((prevValues) => ({
      ...prevValues,
      [question.id]: { value, textValue, extraValues },
    }));
    unifiedCallback({ [question.id]: { value, textValue, extraValues } }, lastFieldModified);
  };

  const handlerDateChange = (arrDate, id) => {
    const lastFieldModified = {
      id,
      value: arrDate[0],
      textValue: arrDate[1]
    }
    setStateForm((prevValues) => ({
      ...prevValues,
      [id]: { value: arrDate[0], textValue: arrDate[1] },
    }));
    unifiedCallback({ [id]: { value: arrDate[0], textValue: arrDate[1] } }, lastFieldModified);
  };

  const handleStaticDateChange = (params) => {
    const { jobType, startDate, endDate, id, duration, availableResources } = params;
    setAccountState((prevState) => ({
      ...prevState,
      skeduloJobData: { ...skeduloJobData, startDate, endDate, availableResources }
    }));

    const lastFieldModified = {
      id,
      value: startDate,
      textValue: startDate,
    };

    setStateForm((prevValues) => ({
      ...prevValues,
      [id]: {
        value: startDate.toString(),
        textValue: startDate.toString(),
        extraValues: {
          "jobType": jobType,
          "startDate": startDate.toString(),
          "endDate": endDate.toString(),
          "duration": duration
        }
      },
    }));

    unifiedCallback({
      [id]: {
        value: startDate.toString(),
        textValue: startDate.toString(),
        extraValues: {
          "jobType": jobType,
          "startDate": startDate.toString(),
          "endDate": endDate.toString(),
          "duration": duration
        }
      },
    }, lastFieldModified);
  };

  const handlerAddressChange = (isValid, completeAddress, barcode) => {
    const lastFieldModified = {
      ...completeAddress,
      isValid,
      barcode
    }
    setStateForm((prevStateForm) => ({
      ...prevStateForm,
      ...completeAddress,
    }));
    unifiedCallback({ ...completeAddress }, lastFieldModified);
  };

  const handlerAutocompleteChange = (value, id) => {
    const lastFieldModified = {
      id,
      value: value.value,
      textValue: value.textValue
    }
    const inputValue = { [id]: value }
    setStateForm((prevStateForm) => ({
      ...prevStateForm,
      ...inputValue,
    }));
    unifiedCallback({ ...inputValue }, lastFieldModified);
  };

  const handleExpandedTandc = (id, tandcReaded) => {
      setTandcReaded(tandcReaded);
      const value = stateForm[id];
      const lastFieldModified = {
          id,
          value: value.value,
          textValue: value.textValue,
          type: value.type
      };

      value.extraValues = { tandcReaded }
      setStateForm((prevStateForm) => ({
          ...prevStateForm,
          [id]: {
              value: value.value,
              textValue: value.value,
              type: value.type,
              extraValues: { tandcReaded }
          },
      }));
      unifiedCallback(
          {
              value: value.value,
              textValue: value.value,
              type: value.type,
              extraValues: { tandcReaded },
          },
          lastFieldModified
      );
  };

  const handlerCheckboxChange = (value, id, question) => {
    const initialValue = stateForm[id];
    if (Array.isArray(id)) {
      let newTandcState = {};
      id.forEach((element) => {
        newTandcState = {
          ...newTandcState,
          [element]: { value: value, textValue: value, type: question.field?.type, extraValues: initialValue.extraValues },
        };
      });
      setStateForm((prevStateForm) => ({
        ...prevStateForm,
        ...newTandcState,
      }));
      unifiedCallback({ ...newTandcState });
    } else {
      setStateForm((prevStateForm) => ({
        ...prevStateForm,
        [id]: { value: value, textValue: value, extraValues: initialValue.extraValues },
      }));
      unifiedCallback({ [id]: { value: value, textValue: value, extraValues: initialValue.extraValues } });
    }
  };

  const handleFileUpload = (files, id) => {
    let values = [];
    if (files.length === 0) {
      values = null;
      setStateForm((prevValues) => ({
        ...prevValues,
        [id]: { value: values, textValue: "" },
      }));
      unifiedCallback({ [id]: { value: values, textValue: "" } });
    } else {
      let filesCount = 0;
      files.forEach((file) => {
        if (file.errors) {
          values = null;
        } else {
          values.push(file);
          filesCount++;
        }
      });
      setStateForm((prevValues) => ({
        ...prevValues,
        [id]: { value: values, textValue: "", extraValues: { filesCount } },
      }));
      unifiedCallback({
        [id]: { value: values, textValue: "", extraValues: { filesCount } },
      });
    }
  };

  const getQuestionComponent = (question) => {
    const type = question.field.type;
    if(truncate_zip_code && question.id === "zip"){
      stateForm[question.id].value = truncateString(stateForm[question.id].value, 5);
      stateForm[question.id].textValue = truncateString(stateForm[question.id].value, 5);
    }
    const answerValue = stateForm[question.id]?.value || "";
    const extraValues = stateForm[question.id]?.extraValues || "";
    const basicProps = {
      key: question.id + "_" + question.position,
      question: question
    }

    if(question.field.display === false) return false;

    switch (type) {
      case "addMore":
        return (
          <AddMoreFieldsButton
            {...basicProps}
            handleOnClick={handlerAddMoreClick}
            onFormAnswered={onFormAnswered}
          />
        );
      case "select":
        return (
          <EligibilitySelect
            {...basicProps}
            value={answerValue}
            handleSelectChange={handleSelectChange}
            customOptions={!isEmpty(customConfig) ? customConfig.dropdownOptions?.[question.id] : null}
            disabled={!isEmpty(customConfig) ? customConfig.disableFields?.[question.id] : false}
          />
        );
      case "autocomplete":
        if (version && parseInt(version) >= 2) {
          return (
            <EligibilityAutocomplete
              {...basicProps}
              value={resetValues?.[question.id]?.value || answerValue}
              handlerAutocompleteChange={handlerAutocompleteChange}
              customOptions={!isEmpty(customConfig) ? customConfig.autocompleteOptions?.[question.id] : null}
              displayField={!isEmpty(customConfig) ? customConfig.autocompleteOptions?.labelField : null}
            />
          );
        } else {
          return (
            <AddressAutocomplete
              {...basicProps}
              baseUrl={baseUrl}
              behaviors= {accountState?.behaviors}
              stateOptions={
                accountState[question.field.options] || []
              }
              value={answerValue}
              handlerAddressChange={handlerAddressChange}
              disabled={!isEmpty(customConfig) ? customConfig.disableFields?.[question.id] : false}
            />
          );
        }
      case "address":
        return (
          <AddressAutocomplete
            {...basicProps}
            baseUrl={baseUrl}
            behaviors= {accountState?.behaviors}
            stateOptions={
              accountState[question.field.options]
            }
            value={answerValue}
            handlerAddressChange={handlerAddressChange}
            disabled={!isEmpty(customConfig) ? customConfig.disableFields?.[question.id] : false}
          />
        );
      case "bool":
      case "checkbox":
        return (
          <EligibilityCheckbox
            {...basicProps}
            name={question.name}
            label={question.label}
            required={question.required}
            checked={answerValue}
            handlerCheckboxChange={handlerCheckboxChange}
          />
        );
      case "file":
        return (
          <UploadFiles
            {...basicProps}
            fileTypes={question.field.fileTypes}
            fileMaxSize={question.field.fileMaxSize}
            handleFileUpload={handleFileUpload}
            value={answerValue || []}
            prevFilesNames={customConfig.uploadFiles?.prevFilesNames || []}
            maxUploadFiles={customConfig.uploadFiles?.maxUploadFiles}
            serviceToUpload={customConfig.uploadFiles?.customerUploadFiles || null}
            serviceToDelete={customConfig.uploadFiles?.customerDeleteFiles || null}
          ></UploadFiles>
        );
      case "tandc":
        if (!question.label) return null;
        if (!question.content) return null;
        return (<EligibilityAccordion
          {...basicProps}
          handleExpandedTandc={handleExpandedTandc}
          value={answerValue}
          extraValues={extraValues}
        />);
      case "date":
        const minDateObj = getDate("min", question);
        const maxDateObj = getDate("max", question);
        return (
          <EligibilityDate
            {...basicProps}
            value={answerValue}
            handlerInputChange={handlerDateChange}
            minDate={minDateObj.date}
            maxDate={maxDateObj.date}
            minDateMessage={minDateObj.message}
            maxDateMessage={maxDateObj.message}
          />
        );
      case "staticDate":
        return (
          <EligibilityStaticDate
            {...basicProps}
            value={answerValue}
            handlerInputChange={handleStaticDateChange}
            productType={productType}
            zipCode={zipCode}
          />
        );
      case "empty":
        return <span />;
      case "textArea":
        return (
          <EligibilityInputArea
            {...basicProps}
            value={answerValue}
            handlerInputChange={handlerInputChange}
            extraValues={extraValues}
            disabled={!isEmpty(customConfig) ? customConfig.disableFields?.[question.id] : false}
          />
        );
      default:
        return (
          <EligibilityInput
            {...basicProps}
            value={answerValue}
            handlerInputChange={handlerInputChange}
            extraValues={extraValues}
            disabled={!isEmpty(customConfig) ? customConfig.disableFields?.[question.id] : false}
          />
        );
    }
  }

  const getEligibilityQuestions = (questions) => {
    return questions.map((question) => {
      if (question.fieldReference) return null;
      const gridValues = defaultGridStyles ? null : gridStyles[question.id]?.gridSize;
      return question.field.type === 'hidden' ? (
        <input
          key={question.id}
          id={question.id}
          value={stateForm[question.id]?.value || ''}
          type="hidden"
        />
      ) : (
        question.field.type === 'addMore'
          ? (getQuestionComponent(question))
          : <Grid
            item
            xs={gridValues?.xs || 12}
            sm={gridValues?.sm || gridValues?.xs || 12}
            md={gridValues?.md || gridValues?.xs || 6}
            lg={gridValues?.lg || gridValues?.xs || 6}
            xl={gridValues?.xl || gridValues?.xs || 6}
            key={`item_${question.id}_${question.position}`}
          > {getQuestionComponent(question)} </Grid>
      )
    })
  }

  return (
    <React.Fragment>
      {getEligibilityQuestions(questions)}
      {tandcQuestion.length !== 0 && (
        <TermsAndConditions
          questions={tandcQuestion}
          answers={stateForm}
          tandcReaded={tandcReaded}
          handlerCheckboxChange={handlerCheckboxChange}
          openTermsAndConditions={openTermsAndConditions}
        />
      )}
    </React.Fragment>
  );
}
